// extracted by mini-css-extract-plugin
module.exports = {"campoValor":"Registro_campoValor__1mUAw"};